import { Button } from "@asosteam/asos-web-component-library-button";
import PropTypes from "prop-types";
import styles from "./styles";
import classnames from "classnames";
import sdkProvider from "../../utilities/sdk-provider";
import { useLocaleProvider, useTranslate } from "../../context/locale-provider";
import { useEffect } from "react";
import { trackPageEvent } from "../../utilities/trackPageEvent";

export default function PreFormContainer() {
  const logIn = async () => {
    const identity = await sdkProvider("identity");
    localStorage.setItem("sv_login_prompted", true);
    identity.login();
  };

  const translate = useTranslate(useLocaleProvider());

  useEffect(() => {
    trackPageEvent({
      content: {
        layout: "student-verification-page-load",
        pageName: "logged out landing page",
      },
    });
  }, []);

  return (
    <div className={classnames(styles.container, "app_leavesden2")}>
      <div>
        <h1 className="app_barnsley5">{translate("sv_intro_header")}</h1>
        <div className={styles.formInfo}>
          <p>{translate("sv_intro_desc_p1")}</p>
          <p>{translate("sv_intro_desc_p2")}</p>
        </div>
        <Button className="app_button" onClick={logIn}>
          {translate("sv_intro_cta")}
        </Button>
      </div>
      <div className={styles.footer}>
        <p>{translate("sv_intro_qualifier")}</p>
      </div>
    </div>
  );
}

PreFormContainer.propTypes = {
  setPromptedToLogin: PropTypes.func.isRequired,
};
